export enum ModoBuscaDataLancamentoEnum {
  DIA_LANCAMENTO = 'DIA_LANCAMENTO',
  DIA_UNICO = 'DIA_UNICO',
  INTERVALO = 'INTERVALO'
}